var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalOrderDrugData
        ? _c(
            "EmptyModal",
            {
              ref: "emptyOrderModal",
              attrs: {
                onModalClose: _vm.closeModal,
                modalData: _vm.modalOrderDrugData,
                onModalAccept: () => _vm.$refs.orderDrugMain.createOrder(),
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("OrderDrugMain", {
                    ref: "orderDrugMain",
                    attrs: {
                      countrySelected: _vm.countrySelected,
                      drugId: _vm.modalOrderDrugData.drug.id,
                      profitCalculation: _vm.profitCalculation,
                      updateOrderedInvoices: _vm.updateOrderedInvoices,
                      closeModal: _vm.closeModal,
                    },
                  }),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData
        ? _c(
            "EmptyModal",
            {
              ref: "emptyModal",
              attrs: {
                onModalClose: _vm.closeModal,
                modalData: _vm.modalData,
                onModalAccept: _vm.saveNewPrices,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "div",
                    [
                      _vm.modalData.type === "countryEdit"
                        ? void 0
                        : [
                            _c(
                              "table",
                              { staticClass: "table table-sm mt-0 priceData" },
                              [
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(
                                      _vm.getSortedProjects(),
                                      function (project, pi) {
                                        return !_vm.hidePrices[project.id]
                                          ? _vm._l(
                                              _vm.getPrices(
                                                _vm.modalData.prices,
                                                project.id
                                              ),
                                              function (price, index) {
                                                return _c("tr", [
                                                  index === 0
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "project_block",
                                                          attrs: {
                                                            rowspan:
                                                              _vm.getPrices(
                                                                _vm.modalData
                                                                  .prices,
                                                                project.id
                                                              ).length,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                project.title
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    [
                                                      pi === 0 &&
                                                      price.qty !== 1
                                                        ? [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    price.freeze,
                                                                  expression:
                                                                    "price.freeze",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                checked:
                                                                  Array.isArray(
                                                                    price.freeze
                                                                  )
                                                                    ? _vm._i(
                                                                        price.freeze,
                                                                        null
                                                                      ) > -1
                                                                    : price.freeze,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        price.freeze,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          null,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            price,
                                                                            "freeze",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            price,
                                                                            "freeze",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        price,
                                                                        "freeze",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group mb-1",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                          },
                                                          [
                                                            index === 0
                                                              ? [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              price.qty
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : [
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              price.qty,
                                                                            expression:
                                                                              "price.qty",
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "custom-select",
                                                                      attrs: {
                                                                        disabled:
                                                                          price.to_remove,
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          [
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              var $$selectedVal =
                                                                                Array.prototype.filter
                                                                                  .call(
                                                                                    $event
                                                                                      .target
                                                                                      .options,
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      return o.selected
                                                                                    }
                                                                                  )
                                                                                  .map(
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      var val =
                                                                                        "_value" in
                                                                                        o
                                                                                          ? o._value
                                                                                          : o.value
                                                                                      return val
                                                                                    }
                                                                                  )
                                                                              _vm.$set(
                                                                                price,
                                                                                "qty",
                                                                                $event
                                                                                  .target
                                                                                  .multiple
                                                                                  ? $$selectedVal
                                                                                  : $$selectedVal[0]
                                                                              )
                                                                            },
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.updateDataToSave(
                                                                                _vm.modalData,
                                                                                "prices",
                                                                                price.site_id,
                                                                                price
                                                                              )
                                                                            },
                                                                          ],
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      9,
                                                                      function (
                                                                        qty
                                                                      ) {
                                                                        return _c(
                                                                          "option",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                value:
                                                                                  qty +
                                                                                  1,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                qty +
                                                                                  1
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ],
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                price.price,
                                                              expression:
                                                                "price.price",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            disabled:
                                                              price.to_remove,
                                                          },
                                                          domProps: {
                                                            value: price.price,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.updateDataToSave(
                                                                _vm.modalData,
                                                                "prices",
                                                                price.site_id
                                                              )
                                                            },
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.$set(
                                                                price,
                                                                "price",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-append",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-text",
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getProfitPercent(
                                                                        _vm.modalData,
                                                                        price.price
                                                                      )
                                                                    ) + "%"
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    [
                                                      _vm.useRates[
                                                        price.site_id
                                                      ] && _vm.showPriceRates
                                                        ? [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    price.packing,
                                                                  expression:
                                                                    "price.packing",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "number",
                                                                disabled:
                                                                  +price.qty !==
                                                                  1,
                                                                placeholder:
                                                                  "фасовка",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  price.packing,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateDataToSave(
                                                                      _vm.modalData,
                                                                      "prices",
                                                                      price.site_id
                                                                    )
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      price,
                                                                      "packing",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    [
                                                      _vm.useRates[
                                                        price.site_id
                                                      ] && _vm.showPriceRates
                                                        ? [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    price.rate,
                                                                  expression:
                                                                    "price.rate",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "number",
                                                                disabled:
                                                                  +price.qty !==
                                                                  1,
                                                                placeholder:
                                                                  "коэффициент",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  price.rate,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateDataToSave(
                                                                      _vm.modalData,
                                                                      "prices",
                                                                      price.site_id
                                                                    )
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      price,
                                                                      "rate",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            price.project_price,
                                                          expression:
                                                            "price.project_price",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "number",
                                                        disabled: "",
                                                        placeholder:
                                                          "цена на сайте",
                                                      },
                                                      domProps: {
                                                        value:
                                                          price.project_price,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.updateDataToSave(
                                                            _vm.modalData,
                                                            "prices",
                                                            price.site_id
                                                          )
                                                        },
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            price,
                                                            "project_price",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    [
                                                      index === 0
                                                        ? [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn btn-xs btn-outline-success",
                                                                attrs: {
                                                                  alt: "добавить цену",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.addExtraProjectPrice(
                                                                        _vm.modalData,
                                                                        price.site_id
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "icon-fa icon-fa-plus",
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        : [
                                                            index !== 0
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn-xs btn-outline-danger",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removePrice(
                                                                            _vm
                                                                              .modalData
                                                                              .id,
                                                                            price
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "icon-fa icon-fa-trash-o",
                                                                      attrs: {
                                                                        "aria-hidden":
                                                                          "true",
                                                                      },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                ])
                                              }
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-content-between flex_gap_10",
                              },
                              [
                                _c("label", { attrs: { for: "check_4" } }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.showPriceRates,
                                        expression: "showPriceRates",
                                      },
                                    ],
                                    attrs: { type: "checkbox", id: "check_4" },
                                    domProps: {
                                      checked: Array.isArray(_vm.showPriceRates)
                                        ? _vm._i(_vm.showPriceRates, null) > -1
                                        : _vm.showPriceRates,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.showPriceRates,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.showPriceRates = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.showPriceRates = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.showPriceRates = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n              Редактировать коэффициенты для цен\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.showPriceRates
                                  ? _c(
                                      "div",
                                      { staticClass: "alert alert-info" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Спеццена: 1/2 значит 100 платформа : 200 сайт, а 2/1 значит 100 платформа : 50 сайт"
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "table table-sm mt-0 table-hover" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.records, function (record) {
              return [
                _c(
                  "tr",
                  {
                    class: {
                      muted:
                        +_vm.updatingDrug === record.id ||
                        (_vm.countrySelected &&
                          _vm.countrySelected !== record.income_country_id) ||
                        record.combined_type === 2,
                    },
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "va-t", attrs: { rowspan: "2" } },
                      [
                        record.options
                          ? _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: record.options.customSelect,
                                    expression: "record.options.customSelect",
                                  },
                                ],
                                staticClass: "mr-1",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    record.options.customSelect
                                  )
                                    ? _vm._i(
                                        record.options.customSelect,
                                        null
                                      ) > -1
                                    : record.options.customSelect,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = record.options.customSelect,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              record.options,
                                              "customSelect",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              record.options,
                                              "customSelect",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          record.options,
                                          "customSelect",
                                          $$c
                                        )
                                      }
                                    },
                                    function ($event) {
                                      return _vm.customUpdateDrug(
                                        record,
                                        "updateCustomSelect"
                                      )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("сохранить препарат")]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("DrugGeneralInfo", {
                          ref: `generalInfo_${record.id}`,
                          refInFor: true,
                          attrs: {
                            drug: record,
                            ordered: _vm.ordered[record.id],
                            invoices: _vm.invoices[record.id],
                            combineInvoices: _vm.combineInvoices?.[record.id],
                            profitCalculation: _vm.profitCalculation,
                            storeDrugData: _vm.storeDrugData[record.id],
                            allStoreDrugsData: _vm.storeDrugData,
                            soldData: _vm.soldData[record.id],
                            ordersStat: _vm.ordersStat[record.id],
                            displaySettings: _vm.displaySettings ?? {},
                            freezeInvoices: _vm.freezeInvoices[record.id],
                            allowToOrder: true,
                            onOrderSelect: (id) => _vm.openOrderModal(id),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "va-t", attrs: { rowspan: "2" } },
                      [
                        _c("DrugSoldStatistics", {
                          attrs: {
                            drug: record,
                            fixedDates: _vm.fixedDates,
                            invoices: _vm.invoices[record.id],
                            ordersStat: _vm.ordersStat[record.id],
                            soldData: _vm.soldData[record.id],
                            soldDiffData: _vm.soldDiffData[record.id],
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex_gap_5 flex-wrap border-bottom mb-1",
                          },
                          [
                            _vm._l(
                              record?.supplier_price_details ?? [],
                              function (sPrice) {
                                return sPrice.supplier_price
                                  ? _c(
                                      "div",
                                      { staticClass: "supplier_price_block" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex flex_gap_10" },
                                          _vm._l(
                                            _vm.getUtekaRates(sPrice, record),
                                            function (kk, ii) {
                                              return _c(
                                                "div",
                                                { staticClass: "card p-1" },
                                                [
                                                  ii === 0
                                                    ? [
                                                        sPrice.supplier_price
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex flex_gap_5",
                                                              },
                                                              [
                                                                sPrice
                                                                  .supplier_price
                                                                  .source_url
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: sPrice
                                                                            .supplier_price
                                                                            .source_url,
                                                                          target:
                                                                            "_blank",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "icon-fa icon-fa-globe",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " Uteka\n                      "
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: {
                                                                      "align-self-center": true,
                                                                      "badge badge-warning":
                                                                        !sPrice
                                                                          .supplier_price
                                                                          .status,
                                                                      "text-muted":
                                                                        sPrice
                                                                          .supplier_price
                                                                          .status,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.printDate(
                                                                          sPrice
                                                                            .supplier_price
                                                                            .scan_date,
                                                                          "DD.MM.YYYY"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "UtekaHistoryRecords",
                                                                  {
                                                                    attrs: {
                                                                      "drug-id":
                                                                        record.id,
                                                                      "detail-id":
                                                                        sPrice.id,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("p", [
                                                          _vm._v(
                                                            "коэффициент: "
                                                          ),
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                kk.value || 1
                                                              )
                                                            ),
                                                          ]),
                                                        ]),
                                                      ],
                                                  _vm._v(" "),
                                                  +(
                                                    sPrice.supplier_price
                                                      ?.extra_data?.in_stores ??
                                                    0
                                                  ) === 0
                                                    ? [
                                                        _c("p", [
                                                          _vm._v(
                                                            "нет в аптеках"
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v("цена на "),
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.printDate(
                                                                  sPrice
                                                                    .supplier_price
                                                                    .extra_data
                                                                    .last_date,
                                                                  "DD.MM.YYYY"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(
                                                            "\n                      - "
                                                          ),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                Math.round(
                                                                  (sPrice
                                                                    .supplier_price
                                                                    ?.extra_data
                                                                    ?.last_price ??
                                                                    0) *
                                                                    (kk.value ||
                                                                      1)
                                                                )
                                                              ) + "р"
                                                            ),
                                                          ]),
                                                        ]),
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex flex_gap_10",
                                                          },
                                                          [
                                                            _c("div", [
                                                              _c("p", [
                                                                _vm._v("мин. "),
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      Math.round(
                                                                        (sPrice
                                                                          .supplier_price
                                                                          ?.extra_data
                                                                          ?.min_price ??
                                                                          0) *
                                                                          (kk.value ||
                                                                            1)
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " Ø\n                          "
                                                                ),
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      Math.round(
                                                                        (sPrice
                                                                          .supplier_price
                                                                          ?.extra_data
                                                                          ?.avarage_price ??
                                                                          0) *
                                                                          (kk.value ||
                                                                            1)
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]),
                                                              _vm._v(" "),
                                                              ii === 0
                                                                ? _c("p", [
                                                                    _vm._v(
                                                                      "аптек: "
                                                                    ),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            sPrice
                                                                              .supplier_price
                                                                              ?.extra_data
                                                                              ?.in_stores ??
                                                                              0
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    sPrice
                                                                      .supplier_price
                                                                      ?.extra_data
                                                                      ?.pickup_shop
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(с/в "
                                                                            ),
                                                                            _c(
                                                                              "strong",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    sPrice
                                                                                      .supplier_price
                                                                                      .extra_data
                                                                                      .pickup_shop
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              ")"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ])
                                                                : _vm._e(),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                  _vm._v(" "),
                                                  kk.comment
                                                    ? _c("p", [
                                                        _vm._v(
                                                          _vm._s(kk.comment)
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e()
                              }
                            ),
                            _vm._v(" "),
                            _vm._l(record.drug_relations, function (rd) {
                              return rd?.related_drug?.actual_stat
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "supplier_price_block card p-1",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "003: " +
                                            _vm._s(rd.related_drug?.title)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex flex_gap_10" },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("LoadStoreTrendData", {
                                                attrs: {
                                                  type: "price",
                                                  record:
                                                    rd.related_drug.actual_stat,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    rd.related_drug.actual_stat
                                                      .price
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _c("LoadStoreTrendData", {
                                                attrs: {
                                                  type: "store",
                                                  trend:
                                                    +rd.related_drug.actual_stat
                                                      .store_trend,
                                                  record:
                                                    rd.related_drug.actual_stat,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    rd.related_drug.actual_stat
                                                      .stores
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "va-t" },
                      [
                        !(_vm.hideBlocks && _vm.hideBlocks.priceEdit) &&
                        _vm.masterChanges[record.id]
                          ? [
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-control custom-radio",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.masterChanges[record.id]
                                              .updateType,
                                          expression:
                                            "masterChanges[record.id].updateType",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "radio",
                                        id: `customRadio_${record.id}_1`,
                                        value: "1",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.masterChanges[record.id]
                                            .updateType,
                                          "1"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.masterChanges[record.id],
                                            "updateType",
                                            "1"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "custom-control-label pointer",
                                        attrs: {
                                          for: `customRadio_${record.id}_1`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Разные цены по\n                  проектам"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-control custom-radio",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.masterChanges[record.id]
                                              .updateType,
                                          expression:
                                            "masterChanges[record.id].updateType",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "radio",
                                        id: `customRadio_${record.id}_2`,
                                        value: "2",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.masterChanges[record.id]
                                            .updateType,
                                          "2"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.masterChanges[record.id],
                                            "updateType",
                                            "2"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "custom-control-label pointer",
                                        attrs: {
                                          for: `customRadio_${record.id}_2`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Фиксированная\n                  цена"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Мастер цена"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group mb-1" }, [
                                _vm._m(1, true),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.masterChanges[record.id].price,
                                      expression:
                                        "masterChanges[record.id].price",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: {
                                    value: _vm.masterChanges[record.id].price,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.masterChanges[record.id],
                                        "price",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.getSortedPrices(
                                  _vm.masterChanges[record.id].extraPrices
                                ),
                                function (price, priceIndex) {
                                  return _c(
                                    "div",
                                    { staticClass: "input-group" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: price.qty,
                                                  expression: "price.qty",
                                                },
                                              ],
                                              staticClass: "custom-select",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    price,
                                                    "qty",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(9, function (qty) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: { value: qty + 1 },
                                                },
                                                [_vm._v(_vm._s(qty + 1))]
                                              )
                                            }),
                                            0
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: price.price,
                                            expression: "price.price",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "number",
                                          placeholder: "цена",
                                        },
                                        domProps: { value: price.price },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              price,
                                              "price",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-append" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "custom-control custom-checkbox",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: price.setAll,
                                                    expression: "price.setAll",
                                                  },
                                                ],
                                                staticClass:
                                                  "custom-control-input",
                                                attrs: {
                                                  type: "checkbox",
                                                  id: `set_all_${record.id}_qty_${price.qty}`,
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    price.setAll
                                                  )
                                                    ? _vm._i(
                                                        price.setAll,
                                                        null
                                                      ) > -1
                                                    : price.setAll,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = price.setAll,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            price,
                                                            "setAll",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            price,
                                                            "setAll",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        price,
                                                        "setAll",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "custom-control-label",
                                                  attrs: {
                                                    for: `set_all_${record.id}_qty_${price.qty}`,
                                                  },
                                                },
                                                [_vm._v("Все")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "remove_extra_price_block",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-danger btn-xs",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeExtraPrice(
                                                        record.id,
                                                        priceIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "x\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-info mt-1 mb-1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addExtraPrice(record.id)
                                    },
                                  },
                                },
                                [_vm._v("Добавить цену")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-success mb-1 mt-1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updatePrices(record)
                                    },
                                  },
                                },
                                [_vm._v("Установить цены")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-info mb-1 mt-1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPriceModal(record)
                                    },
                                  },
                                },
                                [_vm._v("Управление ценами")]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-1" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Цены для справочных"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.fixedPrice[12][record.id],
                                  expression: "fixedPrice[12][record.id]",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.fixedPrice[12][record.id],
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.fixedPrice[12],
                                    record.id,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-info",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateFixedPrices(record.id)
                                    },
                                  },
                                },
                                [_vm._v("Установить")]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("Продажи по ценам "),
                          +record.pack_set !== 1
                            ? _c("span", [_vm._v("(в зав.уп.)")])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex" },
                          _vm._l(_vm.monthsList, function (monthNum, i) {
                            return _c(
                              "div",
                              { staticClass: "sold_price_data_block" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.monthNames[monthNum]) +
                                    "\n              "
                                ),
                                _c(
                                  "div",
                                  _vm._l(
                                    (_vm.soldData[record.id] &&
                                      _vm.soldData[record.id][i + 1] &&
                                      _vm.soldData[record.id][i + 1].prices) ||
                                      [],
                                    function (qty, price) {
                                      return _c("p", [
                                        _c(
                                          "strong",
                                          [
                                            +record.pack_set > 1
                                              ? [
                                                  _vm._v(
                                                    "\n                      (K)" +
                                                      _vm._s(
                                                        price * +record.pack_set
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(price) +
                                                      "\n                    "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                        _vm._v(
                                          ": " +
                                            _vm._s(qty) +
                                            "\n                "
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        !_vm.extraSoldData[record.id] ||
                        _vm.extraSoldData[record.id].loading
                          ? [
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Показать еще +3 месяца",
                                  loading:
                                    _vm.extraSoldData[record.id]?.loading,
                                  color: _vm.$constants.SUCCESS_COLOR,
                                  onClick: () =>
                                    _vm.getSoldStatistics(record.id),
                                  className: "btn btn-xs btn-outline-success",
                                },
                              }),
                            ]
                          : [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                _vm._l(
                                  _vm.extraSoldData[record.id].stat,
                                  function (es, i) {
                                    return _c(
                                      "div",
                                      { staticClass: "sold_price_data_block" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(es.title) +
                                            "\n                "
                                        ),
                                        _vm._l(
                                          es.prices,
                                          function (qty, price) {
                                            return _c("p", [
                                              _c("strong", [
                                                _vm._v(_vm._s(price)),
                                              ]),
                                              _vm._v(": " + _vm._s(qty)),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "va-t" }, [
                      _vm.drugsTasks[record.id]
                        ? _c(
                            "div",
                            { staticClass: "mb-1" },
                            [
                              _vm._l(_vm.drugsTasks[record.id], function (t) {
                                return [
                                  _c("PriceActivityChangesBlock", {
                                    attrs: { task: t },
                                  }),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      record.black_list && record.black_list.length
                        ? _c(
                            "div",
                            { staticClass: "black_list_block" },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-warning",
                              }),
                              _vm._v(" "),
                              _c("strong", [_vm._v("Запись в черном списке")]),
                              _vm._v(" "),
                              _c(
                                "v-popover",
                                {
                                  staticClass: "inline",
                                  attrs: {
                                    placement: "left",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "popover_span" }, [
                                    _vm._v("i"),
                                  ]),
                                  _vm._v(" "),
                                  _c("template", { slot: "popover" }, [
                                    _c(
                                      "div",
                                      _vm._l(record.black_list, function (r) {
                                        return _c(
                                          "div",
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    (r.extra_data &&
                                                      r.extra_data.site_id &&
                                                      _vm.getProfectById(
                                                        r.extra_data.site_id
                                                      ).title) ||
                                                      "Все проекты"
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            r.comments && r.comments.comment
                                              ? [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        r.comments &&
                                                          r.comments.comment
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-right text-muted",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(
                                                            r.comments.user_name
                                                          ) +
                                                          ") " +
                                                          _vm._s(
                                                            _vm.printDate(
                                                              r.created_at
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      }),
                                      0
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "table",
                        { staticClass: "table table-sm mt-0 priceData" },
                        [
                          _c(
                            "tbody",
                            [
                              _vm._l(
                                _vm.getSortedProjects(),
                                function (project, ii) {
                                  return [
                                    _c(
                                      "tr",
                                      {
                                        class: `marked_${
                                          _vm.markedPriceLine[record.id]?.[
                                            project.id
                                          ] ?? 0
                                        }`,
                                      },
                                      [
                                        _c(
                                          "td",
                                          { staticClass: "va-m" },
                                          [
                                            _vm.drugLinks[project.id] &&
                                            _vm.drugLinks[project.id][
                                              record.id
                                            ] &&
                                            !_vm.drugLinks[project.id][
                                              record.id
                                            ].loading
                                              ? [
                                                  _vm.drugLinks[project.id][
                                                    record.id
                                                  ].success
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: `${
                                                                _vm.drugLinks[
                                                                  project.id
                                                                ][record.id]
                                                                  .link
                                                              }`,
                                                              target: "_blank",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "icon-fa icon-fa-globe",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.drugLinks[
                                                                project.id
                                                              ][record.id]
                                                                .message ||
                                                                "Err"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ],
                                                ]
                                              : [
                                                  project.url &&
                                                  _vm.getActiveDrug
                                                    ? [
                                                        !(
                                                          _vm.drugLinks[
                                                            project.id
                                                          ] &&
                                                          _vm.drugLinks[
                                                            project.id
                                                          ][record.id] &&
                                                          _vm.drugLinks[
                                                            project.id
                                                          ] &&
                                                          _vm.drugLinks[
                                                            project.id
                                                          ][record.id].loading
                                                        )
                                                          ? _c("i", {
                                                              staticClass:
                                                                "icon-fa icon-fa-cloud-download pointer",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.getActiveDrug(
                                                                      {
                                                                        projectId:
                                                                          project.id,
                                                                        drugId:
                                                                          record.id,
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.drugLinks[
                                                          project.id
                                                        ] &&
                                                        _vm.drugLinks[
                                                          project.id
                                                        ][record.id] &&
                                                        _vm.drugLinks[
                                                          project.id
                                                        ][record.id].loading
                                                          ? _c("clip-loader", {
                                                              staticClass:
                                                                "inline",
                                                              attrs: {
                                                                loading: true,
                                                                color:
                                                                  _vm.$constants
                                                                    .LOADING_COLOR,
                                                                size: "12px",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                            _vm._v(" "),
                                            _c("span", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "#",
                                                    target: "_blank",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openInNewPage(
                                                        "DrugSiteEdit",
                                                        {
                                                          id: record.id,
                                                          projectId: project.id,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-edit",
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(project.title) +
                                                "\n                  "
                                            ),
                                            _vm.getPriceRate(
                                              record.prices,
                                              project.id
                                            )
                                              ? [
                                                  _c(
                                                    "v-popover",
                                                    {
                                                      staticClass: "inline",
                                                      attrs: {
                                                        placement: "left",
                                                        trigger: "hover",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "popover_span",
                                                        },
                                                        [_vm._v("%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        { slot: "popover" },
                                                        [
                                                          _c("div", [
                                                            _c("p", [
                                                              _vm._v(
                                                                "Установлен коэффициент: "
                                                              ),
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .projectPriceRates[
                                                                      project.id
                                                                    ].rate
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                "Установлена фасовка: "
                                                              ),
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .projectPriceRates[
                                                                      project.id
                                                                    ].packing
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                "Цена на платформе * коэффициент / фасовка"
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex change_buttons",
                                            },
                                            [
                                              _vm._l(
                                                _vm.getPrices(
                                                  record.prices,
                                                  project.id
                                                ),
                                                function (price, index) {
                                                  return [
                                                    index === 0 &&
                                                    !(
                                                      _vm.hideBlocks &&
                                                      _vm.hideBlocks.priceEdit
                                                    )
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "btn-group-toggle pointer",
                                                              attrs: {
                                                                "data-toggle":
                                                                  "buttons",
                                                              },
                                                              on: {
                                                                click: () => {
                                                                  price.is_active =
                                                                    !price.is_active
                                                                  _vm.updateDataToSave(
                                                                    record,
                                                                    "is_active",
                                                                    price.site_id
                                                                  )
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  class: {
                                                                    "btn btn-outline-primary": true,
                                                                    active:
                                                                      price.is_active,
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            price.is_active,
                                                                          expression:
                                                                            "price.is_active",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        Array.isArray(
                                                                          price.is_active
                                                                        )
                                                                          ? _vm._i(
                                                                              price.is_active,
                                                                              null
                                                                            ) >
                                                                            -1
                                                                          : price.is_active,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              price.is_active,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                null,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                _vm.$set(
                                                                                  price,
                                                                                  "is_active",
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  )
                                                                                )
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                _vm.$set(
                                                                                  price,
                                                                                  "is_active",
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    )
                                                                                )
                                                                            }
                                                                          } else {
                                                                            _vm.$set(
                                                                              price,
                                                                              "is_active",
                                                                              $$c
                                                                            )
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    "A\n                          "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "btn-group-toggle pointer",
                                                              attrs: {
                                                                "data-toggle":
                                                                  "buttons",
                                                              },
                                                              on: {
                                                                click: () => {
                                                                  price.order_allow =
                                                                    !price.order_allow
                                                                  _vm.updateDataToSave(
                                                                    record,
                                                                    "order_allow",
                                                                    price.site_id
                                                                  )
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  class: {
                                                                    "btn btn-outline-primary": true,
                                                                    active:
                                                                      price.order_allow,
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            price.order_allow,
                                                                          expression:
                                                                            "price.order_allow",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        Array.isArray(
                                                                          price.order_allow
                                                                        )
                                                                          ? _vm._i(
                                                                              price.order_allow,
                                                                              null
                                                                            ) >
                                                                            -1
                                                                          : price.order_allow,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              price.order_allow,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                null,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                _vm.$set(
                                                                                  price,
                                                                                  "order_allow",
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  )
                                                                                )
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                _vm.$set(
                                                                                  price,
                                                                                  "order_allow",
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    )
                                                                                )
                                                                            }
                                                                          } else {
                                                                            _vm.$set(
                                                                              price,
                                                                              "order_allow",
                                                                              $$c
                                                                            )
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    "З\n                          "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "btn-group-toggle pointer",
                                                              attrs: {
                                                                "data-toggle":
                                                                  "buttons",
                                                              },
                                                              on: {
                                                                click: () => {
                                                                  price.redirect_type =
                                                                    !price.redirect_type
                                                                  _vm.updateDataToSave(
                                                                    record,
                                                                    "redirect_type",
                                                                    price.site_id
                                                                  )
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  class: {
                                                                    "btn btn-outline-primary": true,
                                                                    active:
                                                                      price.redirect_type,
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            price.redirect_type,
                                                                          expression:
                                                                            "price.redirect_type",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        Array.isArray(
                                                                          price.redirect_type
                                                                        )
                                                                          ? _vm._i(
                                                                              price.redirect_type,
                                                                              null
                                                                            ) >
                                                                            -1
                                                                          : price.redirect_type,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              price.redirect_type,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                null,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                _vm.$set(
                                                                                  price,
                                                                                  "redirect_type",
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  )
                                                                                )
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                _vm.$set(
                                                                                  price,
                                                                                  "redirect_type",
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    )
                                                                                )
                                                                            }
                                                                          } else {
                                                                            _vm.$set(
                                                                              price,
                                                                              "redirect_type",
                                                                              $$c
                                                                            )
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    "R\n                          "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.hidePrices[
                                                      price.site_id
                                                    ]
                                                      ? [
                                                          index < 2
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "price_span",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      price.qty
                                                                    ) + ": "
                                                                  ),
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        price.price
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(
                                                                    " (" +
                                                                      _vm._s(
                                                                        _vm.getProfitPercent(
                                                                          record,
                                                                          price.price
                                                                        )
                                                                      ) +
                                                                      "%)"
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "price_span",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      price.qty
                                                                    ) + " ..."
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      : _vm._e(),
                                                  ]
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.priceChanges
                                          ? [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "price_changes_block",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex change_buttons",
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.getPrices(
                                                          _vm.priceChanges,
                                                          project.id
                                                        ),
                                                        function (
                                                          price,
                                                          index
                                                        ) {
                                                          return [
                                                            !_vm.hidePrices[
                                                              price.project_id
                                                            ]
                                                              ? [
                                                                  index < 2
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "price_span",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              price.qty
                                                                            ) +
                                                                              ": "
                                                                          ),
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  price.price
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " (" +
                                                                              _vm._s(
                                                                                _vm.getProfitPercent(
                                                                                  record,
                                                                                  price.price
                                                                                )
                                                                              ) +
                                                                              "%)"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "price_span",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              price.qty
                                                                            ) +
                                                                              " ..."
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ]
                                                              : _vm._e(),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex_gap_5" },
                        [
                          _vm._l(
                            _vm.getPrices(record.prices, 1),
                            function (price) {
                              return price.qty === 1
                                ? [
                                    _c(
                                      "v-popover",
                                      {
                                        staticClass: "inline align-self-center",
                                        attrs: {
                                          placement: "left",
                                          trigger: "hover",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "popover_span" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-calculator",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("template", { slot: "popover" }, [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getProfitPercent(
                                                  record,
                                                  price.price,
                                                  true
                                                )
                                              ),
                                            },
                                          }),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ]
                                : _vm._e()
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "badge badge-warning small_badge pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.openActivationDelay(record)
                                },
                              },
                            },
                            [_c("v-icon", { attrs: { name: "clock" } })],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.countrySelected &&
                      _vm.countrySelected !== record.income_country_id
                        ? _c("div", { staticClass: "no_country_notice" }, [
                            _vm._v(
                              "\n            Не основная страна закупки\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      record.combined_type === 2
                        ? _c("div", { staticClass: "no_country_notice" }, [
                            _vm._v(
                              "\n            Препарат не для продажи отдельно!\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("tr", [
                  _vm.soldData[record.id]?.options?.showStoreTrend
                    ? _c(
                        "td",
                        { attrs: { colspan: "2" } },
                        [_c("StoreTrends", { attrs: { drug: record } })],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "25%" } }),
        _vm._v(" "),
        _c("th", { attrs: { width: "20%" } }),
        _vm._v(" "),
        _c("th", { attrs: { width: "35%" } }, [_vm._v("Цены")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("select", { staticClass: "custom-select", attrs: { disabled: "" } }, [
        _c("option", { attrs: { value: "1", selected: "" } }, [_vm._v("1")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }